/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs */

const en_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert surround ♪♪ to all selected events`)
};

const fr_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer des notes de musique entourees ♪♪ pour tous les evenements selectionnes`)
};

const de_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge Surround ♪♪ zu allen ausgewählten Ereignissen hinzu`)
};

const it_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci surround ♪♪ a tutti gli eventi selezionati`)
};

const ru_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить объемный звук ♪♪ ко всем выбранным событиям`)
};

const es_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar sonido envolvente ♪♪ en todos los eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为所有选定事件插入环绕音♪♪`)
};

const ja_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したすべてのイベントにサラウンド♪♪を挿入します`)
};

const hi_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी चयनित इवेंट्स में सराउंड ♪♪ डालें`)
};

const pt_pt2_shortcut_keys_desc_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir som surround ♪♪ em todos os eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Insert surround ♪♪ to all selected events" |
*
* @param {Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_surround_music_notes_double = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
	return en_shortcut_keys_desc_insert_surround_music_notes_double(inputs)
});